<template>
    <div id="table-demo">

    <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
            <vs-row>
                <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
            <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"/>
            <vs-tooltip text="Tambah">
              <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
            </vs-tooltip>
			<vs-tooltip text="Lihat" v-if="btnView === true">
				<vs-button radius size="large" type="border" color="#5d9fc6" icon="print" class="ml-3"  @click="$router.push({name: 'purchase-view', params: {id: data.id, type:'view' }})"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Proses" v-if="btnProcess === true">
				<vs-button radius size="large" type="border" color="primary" icon="send" class="ml-3" @click="openConfirm()"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Diterima" v-if="btnReceive === true">
				<vs-button radius size="large" type="border" color="warning" icon="call_received" class="ml-3" @click="openReceive()"></vs-button>														
			</vs-tooltip>
			<vs-tooltip text="Hapus" v-if="btnDel === true">
				<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="openDelete()"></vs-button>														
			</vs-tooltip>
          </vs-col>
        </vs-row>
      </vx-card>
    </div>      
      
      <vx-card title="List Purchase Order" class="sticky-table-content mt-sticky">
        <vs-table stripe max-items="10" class="mb-base" :data="listData" style="text-align:center;" @selected="handleSelected">
            <template slot="thead">
                <vs-th>Kode</vs-th>
                <vs-th>Supplier</vs-th>
                <vs-th>Tanggal Order</vs-th>
                <vs-th>Tanggal Terima</vs-th>
				<vs-th>Requestor</vs-th>
				<vs-th>Status</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].code}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].supplierName}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].purchaseDate}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].receiveDate}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].requestorName}}
                    </vs-td>					
                    <vs-td>
                        {{data[indextr].statusName}}
                    </vs-td>										
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>			
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
export default {
	data() {
		return {
			idSelected: null,
			listData: [],
			loading: true,
			perPage: 50,
			page: 1,
      		totalItem: 1,
	  
			btnView: false,
			btnProcess: false,	
			btnReceive: false,
			btnEdit: false,
			btnDel: false,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			this.listData= {maxPage:0, data: []};
			const frm = await stock.listPurchaseOrder(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			}
		},
		async firstLoad() {
			this.find(1);
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnDel = false;
			this.btnEdit = false;
			this.btnView = false;
			this.btnProcess = false;
			this.btnReceive = false;

			if (this.checkStatusCode(tr.id, 'DFT') == true) {
				this.btnEdit = true;
				this.btnProcess = true;
			}
			if (this.checkStatusCode(tr.id, 'ISU') == true) {
				this.btnView = true;
				this.btnReceive = true;
				this.btnDel = true;
			}
		},        
		async getCityByProvince(first) {
			if (this.model.provinceId) {
				const city = await ref.getCityOfId(
					this.model.provinceId
				);
				if (first) {
					tool.copyValuesToDropDown(
						this.schema.fields,
						"regencyId",
						city.data.data
					);
				} else {
					tool.resetAndCopyValuesToDropDown(
						this.schema.fields,
						"regencyId",
						city.data.data,
						this.model
					);
				}
			}
		},
		async getAllProvince() {
			const prov = await ref.getAllProvince();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"provinceId",
				prov.data.data
			);
		},
		async getBulan() {
			const prov = await ref.getBulan();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"month",
				prov.data.data
			);
		},		
		async getTahun() {
			const prov = await ref.getTahun();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"year",
				prov.data.data
			);
		},
		openConfirm() {
			var st = this.checkStatusCode(this.idSelected, 'DFT');
			if (st == false) {
				return;
			}
			let msg = 'Apakah anda akan menyetujui Purchase Order ini ?';
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: msg,
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},		
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
			let md = {id: this.idSelected};
			stock.publishPurchaseOrder(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.firstLoad();
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},
		openReceive() {
			var st = this.checkStatusCode(this.idSelected, 'ISU');
			if (st == false) {
				return;
			}
			this.$router.push({name: 'purchase-receive', params:{ id: this.idSelected}});
		},		
		submitDataReceive() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
			let md = {id: this.idSelected};
			stock.receivePurchaseOrder(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.firstLoad();
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},		
		checkStatusCode(id, status) {
			for (var i = 0; i < this.listData.length; i++) {
				var e = this.listData[i];
				if (e.id == id) {
					if (e.statusCode == status) {
						return true;
					}
				}				
			}
			return false;
		},
		create() {
			this.$router.push('/stock/purchase/create');
		},		
	},
	computed: {},
	created() {
		this.firstLoad();
	},
	watch: {
		page: function(newValue, oldValue) {
			// here you can do whatever you want
			this.find(newValue);
		}
	}
};
</script>